import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { BrowserModule } from '@angular/platform-browser';
import { HostAppWidgetsModule } from '@aot/host-app-widgets-demo';

@NgModule({
  imports: [CommonModule, BrowserModule,HostAppWidgetsModule],
  declarations: [LoginComponent],
  exports: [LoginComponent]
})
export class LoginModule {}
